import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { secondsToHours } from '../utils/time';

@Pipe({ name: 'secondsToHours' })
export class SecondsToHoursPipe implements PipeTransform {
  @memoize()
  public transform(seconds?: number | null, includeSeconds = false): string {
    return secondsToHours(seconds || 0, includeSeconds);
  }
}
